window.renderBadge = function () {
    // The Google platform.js loader has a problem where on a fast connection (or cached) it may have loaded the js and
    // fired the url specified callback before it has initialised window.gapi. This is a workaround for that and was
    // sourced from info at https://github.com/google/google-api-javascript-client/issues/399 and https://github.com/rice-apps/match/issues/10 .
    if (window.gapi) {
        var GoogleMerchantId = document.head.querySelector("meta[name='GoogleMerchantId']").content;
        var ratingBadgeContainer = document.createElement("div");
        document.body.appendChild(ratingBadgeContainer);
        window.gapi.load('ratingbadge', function () {
            window.gapi.ratingbadge.render(ratingBadgeContainer, { "merchant_id": GoogleMerchantId });
        });
    }
    else {
        setTimeout(window.renderBadge, 1);
    }
}
